import { COLOR_TAG_TYPE } from './color';

/**
 * 实名认证状态
 */
export enum MchVerifyStatus {
    Default = '',
    Auditing = 0, // 审核中
    BeModify = 1, // 审核拒绝，待修改资料
    PaperSending = 2, // 待邮寄合同
    PaperProcessing = 3, // 合同审核中
    Success = 4, // 审核成功
    NotRealName = -1, // 未认证
}

export const MchVerifyStatusList = Object.freeze([
    {
        key: MchVerifyStatus.Default,
        label: 'account.status.all',
        color: COLOR_TAG_TYPE.default,
    },
    {
        key: MchVerifyStatus.NotRealName,
        label: 'account.status.not_audit',
        color: COLOR_TAG_TYPE.error,
    },
    {
        key: MchVerifyStatus.Auditing,
        label: 'account.status.auditing',
        color: COLOR_TAG_TYPE.processing,
    },
    {
        key: MchVerifyStatus.PaperSending,
        label: 'account.status.page_tobe_submit',
        color: COLOR_TAG_TYPE.error,
    },
    {
        key: MchVerifyStatus.PaperProcessing,
        label: 'account.status.page_processing',
        color: COLOR_TAG_TYPE.warning,
    },
    {
        key: MchVerifyStatus.Success,
        label: 'account.status.audit_agree',
        color: COLOR_TAG_TYPE.success,
    },
    {
        key: MchVerifyStatus.BeModify,
        label: 'account.status.be_modify',
        color: COLOR_TAG_TYPE.error,
    },
]);

export const getMchVerifyStatus = (status: number | undefined) => {
    return MchVerifyStatusList.find((i) => i.key === status) || MchVerifyStatusList[2];
};
